import { Column, Columns } from '@vtex/admin-ui'
import {
  Accumulate,
  Accumulations,
  AdditionalInformation,
  BIN,
  Budget,
  Cluster,
  Conditions,
  MaxUsage,
  MaxUsagePerClient,
  Origin,
  PaymentMethods,
  PromotionHighlight,
  Restrictions,
  SalesChannels,
  Sellers,
  ShippingLocation,
  ShippingMethods,
  Storefront,
  UTM,
} from 'ui'
import { GeneralInformation } from '../../GeneralInformation'
import { StackedBoxes } from '../../StackedBoxes'
import { BuyAndWinEffect } from './BuyAndWinEffect'

export default function BuyAndWinForm() {
  return (
    <Columns space="$space-20">
      <Column units={7}>
        <GeneralInformation />
        <BuyAndWinEffect name="buyAndWin" />
        <Conditions>
          <PaymentMethods name="conditions.paymentMethods" />
          <BIN name="conditions.bin" />
          <Cluster name="conditions.cluster" />
          <ShippingMethods name="conditions.shippingMethods" />
          <ShippingLocation name="conditions.shippingLocation" />
          <UTM name="conditions.utm" />
        </Conditions>
        <Restrictions>
          <MaxUsage name="restrictions.maxUsage" />
          <MaxUsagePerClient name="restrictions.maxUsagePerClient" />
        </Restrictions>
        <Accumulations>
          <Accumulate name="restrictions.accumulate" />
        </Accumulations>
        <Storefront>
          <PromotionHighlight name="storefront.highlight" />
          <AdditionalInformation name="storefront.additionalInformation" />
        </Storefront>
      </Column>
      <Column>
        <StackedBoxes>
          <Origin name="restrictions.origin" />
          <SalesChannels name="restrictions.salesChannels" />
          <Budget name="restrictions.budget" />
          <Sellers name="restrictions.sellers" />
        </StackedBoxes>
      </Column>
    </Columns>
  )
}
